import React, { Component } from 'react';
import _ from 'lodash'

import questions from './data/questions'
import partyNames from './data/parties'
import icons from './icons'
import ResultCard from './ResultCard'

import { setState } from './lib/state'
import { updatePath } from './lib/path'
import t from './translate/t'

import getResults from './lib/getResults'

const MAX_WEIGHTED_OPINIONS = window.CANDIDATE ? 3 : 1

class Quiz extends Component {
  state = {
    showResults: 30,
    partiesShown: 5,
  }

  answer(event, question, answer, isLastQuestion) {
    const { answers } = this.props

    answers.push({
      question,
      answer,
    })

    setState({ answers })

    const opinions = answers.filter(answer => answer.answer !== 0)
    if (isLastQuestion && opinions.length === 1) {
      this.setWeightedAnswer(opinions[0])
    } else {
      updatePath()
    }
  }

  setWeightedAnswer(item) {
    const weightedAnswer = item.question || false
    const weightedAnswers = [weightedAnswer]
    setState({ weightedAnswers })

    updatePath(true)

    window.scrollTo(0, 0)
  }

  filter(key, value) {
    const { filters } = this.props

    if (filters[key].includes(value)) {
      filters[key] = filters[key].filter(existing => existing !== value)
    } else {
      filters[key].push(value)
    }

    setState({ filters })
  }

  changeCurrentlyFilter(type, value) {
    const { filters } = this.props

    if (filters[type] === value) {
      delete filters[type]
    } else {
      filters[type] = value
    }

    setState({ filters })
  }

  render() {
    const { answers, weightedAnswers, district, filters, language, candidateApp } = this.props

    const question = questions[answers.length]

    const back = <div className="py-8 text-center">
      <span
          className="link"
          onClick={event => window.history.back()}
      >
        {t('back')}
      </span>
    </div>

    if (question) {
      const isLastQuestion = answers.length === questions.length - 1
      return <div className="quiz-container">
        <div className="w-full">
          <div className="question mb-8"><h2 className="mb-0">{t(question.id)}</h2></div>
          <div className="text-center">
            <div className="flex flex-row -mx-2 mb-8">
              {question.answers.map(answer => {
                return <div
                  className="card card-hover text-center flex-1 mb-2 mx-2"
                  key={question.id + '-' + answer.value}
                  onClick={event => this.answer(event, question.id, answer.value, isLastQuestion)}
                >{t(answer.name)}</div>
              })}
            </div>
            <div>
              <span
                key={question.id + '-skip'}
                className="card card-hover card-skip mx-auto"
                onClick={event => this.answer(event, question.id, 0, isLastQuestion)}
              >
                {t('skip')}
              </span>
            </div>
            {back}
          </div>
        </div>
      </div>
    }

    const opinions = answers.filter(answer => answer.answer !== 0)

    if (weightedAnswers.length < MAX_WEIGHTED_OPINIONS && opinions.length >= 2) {
      return <div className="quiz-container">
        <div className="w-full py-8">
          <h2>{t('most important')}</h2>
          {opinions.map((answer, index) => {
            return <div
              key={index}
              className="card card-hover text-center mb-2" onClick={() => this.setWeightedAnswer(answer)}
            >
              {t(answer.question)}
            </div>
          })}
          <div className="text-center">
            <span
              className="card card-hover card-skip mt-4"
              onClick={() => this.setWeightedAnswer(false)}
            >
              {t('skip')}
            </span>
          </div>
          {back}
        </div>
      </div>
    }

    let { noResults, candidates, parties, filteredResults, perfectResultsCount, bestResultsCount } = getResults(this.props.allCandidates, district, opinions, weightedAnswers, filters)

    if (noResults) {
      return <div className="flex items-center justify-center flex-1 bg-light pt-2 pb-8 px-2">
        {t('Loading...')}
      </div>
    }
    console.log(filteredResults)

    const ageGroups = _.uniq(candidates.map(item => item.candidate.ageGroup)).filter(exists => exists).sort()
    const genders = _.uniq(candidates.map(item => item.candidate.gender)).filter(exists => exists)

    let title
    let helpText = t('resultshelp')
    if (perfectResultsCount) {
      if (perfectResultsCount === 1) {
        title = `${t("1 matching candidate")}`
      } else {
        title = `${bestResultsCount} ${t("matching")} ${t("candidates")}`
      }
    } else if (filteredResults.length) {
      if (bestResultsCount === 1) {
        title = `${t("1 best matching candidate")}`
      } else {
        title = `${bestResultsCount} ${t("best matching")} ${t("candidates")}`
      }
    } else {
      title = `0 ${t("candidates")}`
    }

    if (opinions.length === 0) {
      title = `${perfectResultsCount} ${t("candidates")}`
      filteredResults = _.sortBy(filteredResults, item => item.candidate.number)
      helpText = t('noopinions')
    }

    return <div className="flex-1 bg-light pt-2 pb-8 px-2">
      <div className="text-center my-6">
        <span
          className="button text-lg"
          onClick={event => window.history.back()}
        >
          {t('change')}
        </span>
      </div>
      <div className="text-sm mt-2 mb-8">
        <h3>{t('Filter results')}</h3>
        <div className="flex flex-row -mx-2 mb-2">
          <div className="flex-1 mx-2">
            <h4>{t('Age')}</h4>
            <div className="-mx-1">
              {ageGroups.map(value => {
                const selected = filters.ageGroup.includes(value)
                return <span key={value} className={"filter-value mx-2 " + (selected && 'selected')} onClick={() => this.filter('ageGroup', value)}>
                  {value} {selected && <span><span dangerouslySetInnerHTML={{ __html: icons.close }} /></span>}
                </span>
              })}
            </div>
          </div>
          <div className="flex-1 mx-2">
            <h4>{t('Gender')}</h4>
            <div className="-mx-1">
              {genders.map(value => {
                const selected = filters.gender.includes(value)
                return <span key={value} className={"filter-value mx-2 " + (selected && 'selected')} onClick={() => this.filter('gender', value)}>
                  {t(`gender-${value}`)} {selected && <span><span dangerouslySetInnerHTML={{ __html: icons.close }} /></span>}
                </span>
              })}
            </div>
          </div>
        </div>
        {/*<div className="mb-2">
            <h4>{t('current')} {t('europarlamentaarikko')}</h4>
            <div className="-mx-1">
                <span className={"filter-value " + (filters.eu === false && 'selected')} onClick={() => this.changeCurrentlyFilter('eu', false)}>{t('Ei')} {filters.eu === false && <span><span dangerouslySetInnerHTML={{ __html: icons.close }} /></span>}</span>
                <span className={"filter-value " + (filters.eu === true && 'selected')} onClick={() => this.changeCurrentlyFilter('eu', true)}>{t('Kyllä')} {filters.eu === true && <span><span dangerouslySetInnerHTML={{ __html: icons.close }} /></span>}</span>
            </div>
        </div>*/}
        <h4>{t('Party')}</h4>
        <div className="-mx-1">
          {_.take(parties, this.state.partiesShown).map(value => {
            const selected = filters.party.includes(value)
            return <span key={value} className={"filter-value mx-2 " + (selected && 'selected')} onClick={() => this.filter('party', value)}>
              {partyNames[value] || value} {selected && <span dangerouslySetInnerHTML={{ __html: icons.close }} />}
            </span>
          })}
          {parties.length > this.state.partiesShown && <div className="text-center link" onClick={() => this.setState({ partiesShown: 100 })}>{t('show more parties')}</div>}
        </div>
      </div>
      <h2>{title}</h2>
      <p className="text-center text-sm">{helpText}</p>

      {filteredResults && _.take(filteredResults, this.state.showResults).map((result, i) => {
        if (i === bestResultsCount) {
          return <div key={result.candidate.number}>
            <h2>{`${filteredResults.length - bestResultsCount} ${t("other")} ${t("candidates")}`}:</h2>
            <ResultCard
              {...result}
            />
          </div>
        }

        return <ResultCard
          key={result.candidate.number}
          {...result}
        />
      })}
      {filteredResults.length > this.state.showResults && <div className="text-center"><div className="button" onClick={() => this.setState({ showResults: this.state.showResults + 20 })}>{t('show more')}</div></div>}
    </div>
  }
}

function getDifference(a,b) {
    return Math.abs(a-b)
}

export default Quiz
